module.exports = __webpack_public_path__ + "img/brand (3).54bc2986.svg";